import React from 'react';
import { Link } from 'react-router-dom';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

const Banner = () => {
    return(
        <>
        <section className="slider">

                <OwlCarousel 
                items={1}
                loop={true}
                nav={true}
                dots={true}
                autoplay={true}
                animateIn={'fadeIn'}
                animateOut={'fadeOut'}
                navText={['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>']}
                className="slider-carousel owl-carousel owl-theme">
                    <div className="slide" style={{backgroundImage:'url("images/slider/sl-01-1920x750.png")'}}>
                    <div className="container">
                        <div className="content">
                            <h2><span className="span-color-size">We Build</span> Your Dream</h2>
                            <div className="text">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Distinctio nobis aliquid sed id saepe. <br />Quasi totam, dolorem repellendus cupiditate! Quos eaque, voluptas doloribus </div>
                            <div className="link-holder">
                                <Link to="#" className="ploting-btn btn-style-two">Read more</Link>
                            </div>
                        </div>
                    </div>
                    </div>

                    <div className="slide" style={{backgroundImage:'url("images/slider/sl-02-1920x750.png")'}}>
                        <div className="container">
                            <div className="content">
                                <h2><span className="span-color-size">Making</span> dreams come true</h2>
                                <div className="text">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Distinctio nobis aliquid sed id saepe. <br />Quasi totam, dolorem repellendus cupiditate! Quos eaque, voluptas doloribus </div>
                                <div className="link-holder">
                                    <Link to="#" className="ploting-btn btn-style-two">learn more</Link> <Link to="#" className="ploting-btn btn-style-three">Our Servics</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </OwlCarousel>
        </section>
        </>
    )
}

export default Banner;